import {
  NodeHomePage,
  NodeHomePageTakeover,
  NodeParagraphPage,
  NodeLandingPage,
  NodeArticle,
  NodeLocation,
  NodePerson,
  NodeProject,
  NodePointOfView,
  NodeVacancy,
  NodeStory,
  NodeOverviewPage,
  NodeCampaignPage,
  NodeCampaignPage2,
} from '../implementations';

const mappers = {
  home_page: NodeHomePage,
  home_page_takeover: NodeHomePageTakeover,
  paragraph_page: NodeParagraphPage,
  landing_page: NodeLandingPage,
  article: NodeArticle,
  location: NodeLocation,
  person: NodePerson,
  project: NodeProject,
  point_of_view: NodePointOfView,
  vacancy: NodeVacancy,
  story: NodeStory,
  overview_page: NodeOverviewPage,
  campaign_page: NodeCampaignPage,
  campaign_page_2: NodeCampaignPage2,
};

export default mappers;
